export default __webpack_public_path__ + "static/media/ff-logo-white.ffeec336.svg";